"use strict";
/**
 * The main constructor class for the Pelias client
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = __importDefault(require("./search/index"));
const index_2 = __importDefault(require("./autocomplete/index"));
class Pelias {
    // Subclasses handle validation of configuration
    constructor(config) {
        this.search = new index_1.default(config);
        this.autocomplete = new index_2.default(config);
    }
}
exports.default = Pelias;
